import { makeStyles } from '@material-ui/core/';
import * as React from 'react';
import useStore from '../store/store';

const EventsPage = () => {
    const setTitle = useStore((state) => state.setTitle);
    const classes = useStyles({});

    React.useEffect(() => {
        setTitle('Genome Portal - News & Events');
    }, [setTitle]);

    return (
        <>
            <div className={classes.root}>
                <div className={classes.header}>
                    <div className={classes.title}>News & Events</div>
                </div>
                <p>Here we will inform you about upcoming events.</p>
            </div>
        </>
    );
};

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        padding: '40px',
        flexDirection: 'column',
        alignItems: 'center',
        flex: '1 0 0',
        alignSelf: 'stretch',
        background: '#fff',
        maxWidth: '600px',
        margin: '40px auto 0',
        borderRadius: '20px',
    },
    header: {
        display: 'flex',
        alignItems: 'center',
        gap: '27px',
    },
    title: {
        display: 'flex',
        color: theme.palette.primary.main,
        fontFamily: 'Poppins',
        fontSize: '32px',
        fontStyle: 'normal',
        fontWeight: 500,
        lineHeight: '150%',
        letterSpacing: '-0.576px',
        marginBottom: '20px',
    },
}));

export default EventsPage;
